// PWA Install Prompt for different platforms
export class PWAPrompt {
  private deferredPrompt: any = null;
  private isIOS = false;
  private isStandalone = false;
  private isMobile = false;

  constructor() {
    this.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    this.isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                       (window.navigator as any).standalone === true;
    
    this.init();
  }

  private init() {
    // Listen for beforeinstallprompt event (Android/Chrome)
    window.addEventListener('beforeinstallprompt', (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      
      // Show button only on mobile devices
      if (this.isMobile) {
        this.showInstallButton();
      }
    });

    // Show instructions for iOS
    if (this.isIOS && !this.isStandalone) {
      this.showIOSInstructions();
    }
  }

  private showInstallButton() {
    // Create "Install App" button
    const installButton = document.createElement('button');
    installButton.textContent = 'Install App';
    installButton.style.cssText = `
      position: fixed;
      bottom: 20px;
      right: 20px;
      background: #007AFF;
      color: white;
      border: none;
      padding: 12px 20px;
      border-radius: 8px;
      font-size: 14px;
      cursor: pointer;
      z-index: 1000;
      box-shadow: 0 4px 12px rgba(0,0,0,0.3);
    `;
    
    installButton.addEventListener('click', () => {
      this.promptInstall();
    });

    document.body.appendChild(installButton);
  }

  private showIOSInstructions() {
    // Show instructions for iOS users
    const iosPrompt = document.createElement('div');
    iosPrompt.innerHTML = `
      <div style="
        position: fixed;
        bottom: 20px;
        left: 20px;
        right: 20px;
        background: rgba(0,0,0,0.9);
        color: white;
        padding: 16px;
        border-radius: 12px;
        font-size: 14px;
        z-index: 1000;
        text-align: center;
      ">
        <p>Add this site to your home screen:</p>
        <p>Tap <strong>⎙</strong> and select <strong>"Add to Home Screen"</strong></p>
        <button onclick="this.parentElement.parentElement.remove()" style="
          background: #007AFF;
          color: white;
          border: none;
          padding: 8px 16px;
          border-radius: 6px;
          margin-top: 8px;
          cursor: pointer;
        ">Got it</button>
      </div>
    `;
    
    document.body.appendChild(iosPrompt);
    
    // Auto-hide after 10 seconds
    setTimeout(() => {
      if (iosPrompt.parentElement) {
        iosPrompt.remove();
      }
    }, 10000);
  }

  public async promptInstall() {
    if (!this.deferredPrompt) {
      return false;
    }

    this.deferredPrompt.prompt();
    const { outcome } = await this.deferredPrompt.userChoice;
    
    if (outcome === 'accepted') {
      console.log('User accepted the install prompt');
    } else {
      console.log('User dismissed the install prompt');
    }
    
    this.deferredPrompt = null;
    return outcome === 'accepted';
  }

  public canInstall(): boolean {
    return !!this.deferredPrompt || (this.isIOS && !this.isStandalone);
  }
}
